/**
 * HelplineSOS REST API Service - DEV
 * HelplineSOS REST API Service - Hosted on AWS ECS Cluster - DEV Environment Last Updated On Mon, 7 Sep 2020 17:23:26 EST
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CallBackDTO } from '../model/callBackDTO';
import { CallBackFollowUpNoteDTO } from '../model/callBackFollowUpNoteDTO';
import { CallBackNoteDTO } from '../model/callBackNoteDTO';
import { EndCallBackDTO } from '../model/endCallBackDTO';
import { UpdateCallBackDTO } from '../model/updateCallBackDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CallBackControllerService {

    protected basePath = 'https://api-dev.helplinesos.org';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Delete a CallBack
     * Delete&#39;S a CallBack
     * @param callBackId callBackId
     * @param callId callId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteCallBackUsingDELETE(callBackId: number, callId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteCallBackUsingDELETE(callBackId: number, callId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteCallBackUsingDELETE(callBackId: number, callId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteCallBackUsingDELETE(callBackId: number, callId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (callBackId === null || callBackId === undefined) {
            throw new Error('Required parameter callBackId was null or undefined when calling deleteCallBackUsingDELETE.');
        }

        if (callId === null || callId === undefined) {
            throw new Error('Required parameter callId was null or undefined when calling deleteCallBackUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // authentication (AUTHORIZATION) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/callbacks/${encodeURIComponent(String(callId))}/${encodeURIComponent(String(callBackId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * End CallBack to the Caller
     * Ends&#39;s a CallBack to the Caller
     * @param callBackId callBackId
     * @param callId callId
     * @param endCallBackDTO endCallBackDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public endCallBackUsingPUT(callBackId: number, callId: number, endCallBackDTO: EndCallBackDTO, observe?: 'body', reportProgress?: boolean): Observable<CallBackDTO>;
    public endCallBackUsingPUT(callBackId: number, callId: number, endCallBackDTO: EndCallBackDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CallBackDTO>>;
    public endCallBackUsingPUT(callBackId: number, callId: number, endCallBackDTO: EndCallBackDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CallBackDTO>>;
    public endCallBackUsingPUT(callBackId: number, callId: number, endCallBackDTO: EndCallBackDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (callBackId === null || callBackId === undefined) {
            throw new Error('Required parameter callBackId was null or undefined when calling endCallBackUsingPUT.');
        }

        if (callId === null || callId === undefined) {
            throw new Error('Required parameter callId was null or undefined when calling endCallBackUsingPUT.');
        }

        if (endCallBackDTO === null || endCallBackDTO === undefined) {
            throw new Error('Required parameter endCallBackDTO was null or undefined when calling endCallBackUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // authentication (AUTHORIZATION) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<CallBackDTO>(`${this.basePath}/api/callbacks/${encodeURIComponent(String(callId))}/${encodeURIComponent(String(callBackId))}`,
            endCallBackDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get CallBack Details
     * Get&#39;s CallBack Details
     * @param callBackId callBackId
     * @param callId callId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCallBackUsingGET(callBackId: number, callId: number, observe?: 'body', reportProgress?: boolean): Observable<CallBackDTO>;
    public getCallBackUsingGET(callBackId: number, callId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CallBackDTO>>;
    public getCallBackUsingGET(callBackId: number, callId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CallBackDTO>>;
    public getCallBackUsingGET(callBackId: number, callId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (callBackId === null || callBackId === undefined) {
            throw new Error('Required parameter callBackId was null or undefined when calling getCallBackUsingGET.');
        }

        if (callId === null || callId === undefined) {
            throw new Error('Required parameter callId was null or undefined when calling getCallBackUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (AUTHORIZATION) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<CallBackDTO>(`${this.basePath}/api/callbacks/${encodeURIComponent(String(callId))}/${encodeURIComponent(String(callBackId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get All CallBacks
     * Get&#39;s All CallBacks
     * @param callId callId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCallBacksUsingGET(callId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<CallBackDTO>>;
    public getCallBacksUsingGET(callId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CallBackDTO>>>;
    public getCallBacksUsingGET(callId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CallBackDTO>>>;
    public getCallBacksUsingGET(callId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (callId === null || callId === undefined) {
            throw new Error('Required parameter callId was null or undefined when calling getCallBacksUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (AUTHORIZATION) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<CallBackDTO>>(`${this.basePath}/api/callbacks/${encodeURIComponent(String(callId))}/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Start CallBack to the Caller
     * Starts&#39;s a CallBack to the Caller
     * @param callId callId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public startCallBackUsingPOST(callId: number, observe?: 'body', reportProgress?: boolean): Observable<CallBackDTO>;
    public startCallBackUsingPOST(callId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CallBackDTO>>;
    public startCallBackUsingPOST(callId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CallBackDTO>>;
    public startCallBackUsingPOST(callId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (callId === null || callId === undefined) {
            throw new Error('Required parameter callId was null or undefined when calling startCallBackUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (AUTHORIZATION) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<CallBackDTO>(`${this.basePath}/api/callbacks/${encodeURIComponent(String(callId))}/`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Record Callback Followup Notes
     * Record&#39;s Callback Followup Notes
     * @param callBackFollowUpNoteDTO callBackFollowUpNoteDTO
     * @param callBackId callBackId
     * @param callId callId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateCallBackFollowUpNotesUsingPATCH(callBackFollowUpNoteDTO: CallBackFollowUpNoteDTO, callBackId: number, callId: number, observe?: 'body', reportProgress?: boolean): Observable<CallBackDTO>;
    public updateCallBackFollowUpNotesUsingPATCH(callBackFollowUpNoteDTO: CallBackFollowUpNoteDTO, callBackId: number, callId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CallBackDTO>>;
    public updateCallBackFollowUpNotesUsingPATCH(callBackFollowUpNoteDTO: CallBackFollowUpNoteDTO, callBackId: number, callId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CallBackDTO>>;
    public updateCallBackFollowUpNotesUsingPATCH(callBackFollowUpNoteDTO: CallBackFollowUpNoteDTO, callBackId: number, callId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (callBackFollowUpNoteDTO === null || callBackFollowUpNoteDTO === undefined) {
            throw new Error('Required parameter callBackFollowUpNoteDTO was null or undefined when calling updateCallBackFollowUpNotesUsingPATCH.');
        }

        if (callBackId === null || callBackId === undefined) {
            throw new Error('Required parameter callBackId was null or undefined when calling updateCallBackFollowUpNotesUsingPATCH.');
        }

        if (callId === null || callId === undefined) {
            throw new Error('Required parameter callId was null or undefined when calling updateCallBackFollowUpNotesUsingPATCH.');
        }

        let headers = this.defaultHeaders;

        // authentication (AUTHORIZATION) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<CallBackDTO>(`${this.basePath}/api/callbacks/${encodeURIComponent(String(callId))}/notes/followup/${encodeURIComponent(String(callBackId))}`,
            callBackFollowUpNoteDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Record Callback Notes
     * Record&#39;s A Callback Notes
     * @param callBackId callBackId
     * @param callBackNoteDTO callBackNoteDTO
     * @param callId callId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateCallBackNotesUsingPATCH(callBackId: number, callBackNoteDTO: CallBackNoteDTO, callId: number, observe?: 'body', reportProgress?: boolean): Observable<CallBackDTO>;
    public updateCallBackNotesUsingPATCH(callBackId: number, callBackNoteDTO: CallBackNoteDTO, callId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CallBackDTO>>;
    public updateCallBackNotesUsingPATCH(callBackId: number, callBackNoteDTO: CallBackNoteDTO, callId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CallBackDTO>>;
    public updateCallBackNotesUsingPATCH(callBackId: number, callBackNoteDTO: CallBackNoteDTO, callId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (callBackId === null || callBackId === undefined) {
            throw new Error('Required parameter callBackId was null or undefined when calling updateCallBackNotesUsingPATCH.');
        }

        if (callBackNoteDTO === null || callBackNoteDTO === undefined) {
            throw new Error('Required parameter callBackNoteDTO was null or undefined when calling updateCallBackNotesUsingPATCH.');
        }

        if (callId === null || callId === undefined) {
            throw new Error('Required parameter callId was null or undefined when calling updateCallBackNotesUsingPATCH.');
        }

        let headers = this.defaultHeaders;

        // authentication (AUTHORIZATION) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<CallBackDTO>(`${this.basePath}/api/callbacks/${encodeURIComponent(String(callId))}/notes/${encodeURIComponent(String(callBackId))}`,
            callBackNoteDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update A CallBack
     * Update&#39;s a CallBack
     * @param callBackId callBackId
     * @param callId callId
     * @param updateCallBackDTO updateCallBackDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateCallBackUsingPATCH(callBackId: number, callId: number, updateCallBackDTO: UpdateCallBackDTO, observe?: 'body', reportProgress?: boolean): Observable<CallBackDTO>;
    public updateCallBackUsingPATCH(callBackId: number, callId: number, updateCallBackDTO: UpdateCallBackDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CallBackDTO>>;
    public updateCallBackUsingPATCH(callBackId: number, callId: number, updateCallBackDTO: UpdateCallBackDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CallBackDTO>>;
    public updateCallBackUsingPATCH(callBackId: number, callId: number, updateCallBackDTO: UpdateCallBackDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (callBackId === null || callBackId === undefined) {
            throw new Error('Required parameter callBackId was null or undefined when calling updateCallBackUsingPATCH.');
        }

        if (callId === null || callId === undefined) {
            throw new Error('Required parameter callId was null or undefined when calling updateCallBackUsingPATCH.');
        }

        if (updateCallBackDTO === null || updateCallBackDTO === undefined) {
            throw new Error('Required parameter updateCallBackDTO was null or undefined when calling updateCallBackUsingPATCH.');
        }

        let headers = this.defaultHeaders;

        // authentication (AUTHORIZATION) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<CallBackDTO>(`${this.basePath}/api/callbacks/${encodeURIComponent(String(callId))}/${encodeURIComponent(String(callBackId))}`,
            updateCallBackDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
